export class Charts {
   
    CustomersCount: string ;
    IsCustomersChart: Boolean;
    LoanCount:Number ;
    IsLoanChart: Boolean;
    SavingsCount: Number;
    CompanyId: Number;
    BranchId: Number;
    SaasId:String;
	BranchName: String;
	FromDate: Date;
    ToDate:Date;
}
